/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Platform_OverlineInputs */

const en_mk_platform_overline = /** @type {(inputs: Mk_Platform_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`THE WORKFLOW`)
};

const id_mk_platform_overline = /** @type {(inputs: Mk_Platform_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ALUR KERJA`)
};

/**
* | output |
* | --- |
* | "THE WORKFLOW" |
*
* @param {Mk_Platform_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_platform_overline = /** @type {((inputs?: Mk_Platform_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Platform_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_platform_overline(inputs)
	return en_mk_platform_overline(inputs)
});